import MyCreate from '@/v2/my-create/my-create.vue';
import MyCreateAsk from '@/v2/my-create/ask-goover/my-create-ask.vue';
import { Authority } from '@/shared/security/authority';
import MyCreateReport from '@/v2/my-create/report/my-create-report.vue';
import MyCreateJournalist from '@/v2/my-create/journalist-note/my-create-journalist.vue';
import MyCreateSocial from '@/v2/my-create/social-media-posting/my-create-social.vue';
import MyCreatePodcast from '@/v2/my-create/podcast/my-create-podcast.vue';

export default [
  {
    path: '/my-create',
    name: 'UserMyCreate',
    component: MyCreate,
    meta: { authorities: [Authority.USER], showSideBarMyCreate: true },
    children: [
      { path: '', name: 'MyCreateAsk', component: MyCreateAsk, meta: { authorities: [Authority.USER], showSideBarMyCreate: true } },
      {
        path: 'ask-goover',
        name: 'MyCreateAsk',
        component: MyCreateAsk,
        meta: { authorities: [Authority.USER], showSideBarMyCreate: true },
      },
      {
        path: 'report',
        name: 'MyCreateReport',
        component: MyCreateReport,
        meta: { authorities: [Authority.USER], showSideBarMyCreate: true },
      },
      {
        path: 'journalist-note',
        name: 'MyCreateJournalist',
        component: MyCreateJournalist,
        meta: { authorities: [Authority.USER], showSideBarMyCreate: true },
      },
      {
        path: 'social-media-posting',
        name: 'MyCreateSocial',
        component: MyCreateSocial,
        meta: { authorities: [Authority.USER], showSideBarMyCreate: true },
      },
      {
        path: 'podcast',
        name: 'MyCreatePodcast',
        component: MyCreatePodcast,
        meta: { authorities: [Authority.USER], showSideBarMyCreate: true },
      },
    ],
  },
];
